import DataRoom from './container';

export default DataRoom;
